var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-volume") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.136722415 0.120583649 1.66666667 0.120583649 1.66666667 5.21268407 0.136722415 5.21268407"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.022088782 4.78683333 0.022088782 4.78683333 7.99996257 0 7.99996257"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.333333, 1.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.829033333,0.2645 C0.686366667,0.0858333333 0.419033333,0.0715 0.2567,0.232833333 L0.2567,0.233166667 C0.120366667,0.368833333 0.105033333,0.585833333 0.225366667,0.736166667 C0.6497,1.26483333 0.902366667,1.93583333 0.901366667,2.6665 C0.900366667,3.39716667 0.6447,4.06883333 0.2187,4.59683333 C0.0980333333,4.7465 0.1127,4.96316667 0.2487,5.0995 C0.4097,5.2615 0.6777,5.24783333 0.821033333,5.06983333 C1.3487,4.41183333 1.6657,3.57583333 1.66670951,2.66716667 C1.6687,1.7585 1.35503333,0.9235 0.829033333,0.2645",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.16006667,2.5454 C6.02873333,2.3594 5.75606667,2.3444 5.59506667,2.50506667 L5.59473333,2.50573333 C5.46473333,2.63473333 5.45173333,2.83606667 5.55606667,2.9864 C5.75606667,3.27406667 5.87306667,3.6234 5.8724,4.00006667 C5.87173333,4.37706667 5.75373333,4.72606667 5.5534,5.0134 C5.4484,5.1634 5.46106667,5.3644 5.59006667,5.49373333 C5.75073333,5.65506667 6.02373333,5.6414 6.1554,5.4554 C6.44706667,5.04506667 6.61906667,4.54306667 6.62006862,4.00106667 C6.62073333,3.45873333 6.4504,2.95673333 6.16006667,2.5454",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3785,0.0652666667 L1.85083333,1.80093333 C1.7635,1.86093333 1.5865,1.89826667 1.4345,1.89826667 L0.274833333,1.89826667 C0.123166667,1.89826667 -0.000166666667,2.05026667 -0.000166666667,2.23826667 L-0.000166666667,5.78426667 C-0.000166666667,5.9716 0.123166667,6.12393333 0.274833333,6.12393333 L1.4345,6.12393333 C1.5865,6.12393333 1.7635,6.16126667 1.85083333,6.22093333 L4.3785,7.9566 C4.56183333,8.0826 4.78683333,7.91893333 4.78683333,7.65993333 L4.78683333,0.362266667 C4.78683333,0.103266667 4.56183333,-0.0604 4.3785,0.0652666667",
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/icon-volume.1c0d030accffc99d3ad0d346c040ebb0.svg";
export { ForwardRef as ReactComponent };